export const ADVISOR_TYPE = {
  REGULAR: 'R',
  REGULAR_TRANSIT: 'RT',
  MSV: 'V'
};

export const VEHICLE_MODEL = {
  TRANSIT: 'TRANSIT'
};

export const SERVICE_TYPE_PRIORITY = {
  SERVICE: 1,
  OPTIONAL_REPAIR: 3,
  OPTIONAL_ALIGNMENT_BALANCE: 4
};

export const WHATSAPP_ORIGIN = 'VirtualBooking';

export enum ContactType {
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
  MOBILE_PHONE = 'CELULAR',
  SMS = 'SMS',
  OTHERS = 'OUTROS',
}

export const REGION_C = {
  SA: 'SA',
  THA: 'THA'
};

export const FORD_PROTECT_STATUS_ACTIVE = 'ativo';
export const FORD_PROTECT_STATUS_BLOCKED = 'bloqueado';
export const FORD_PROTECT_STATUS_CANCELED = 'cancelado';
export const FORD_PROTECT_STATUS_FINISHED = 'finalizado';
export const returnMessages = {
  OK: 'OK'
};

export const FORD_PROTECT_EXTEND_WARRANTY = '0BAS';
export const FORD_PROTECT_FORD_GO = 'FDGO';
export const FORD_PROTECT_EXTEND_WARRANTY_COVERAGE = ['ESP', 'FLSN'];
export const FORD_PROTECT_FLEET_VEHICLE = 'FLEE';
export const FORD_PROTECT_MAINTENANCE_COVERAGE = ['QCM', 'FLMT', 'TRUM', 'FLT'];
export const FORD_PROTECT_WEARING_PART_COVERAGE = ['AST'];

export const FORD_PROTECT_COVERAGE_STATUS_ACTIVE = 'ativo';
export const FORD_PROTECT_COVERAGE_STATUS_FINALIZED = 'inativo';
export const sizes_screen = {
  MOBILE: 480,
  IPAD: 1024
};

export enum FordProtectPlanType {
  REVIEW_PLAN = 'RVP',
  OTHER_PLANS = 'OTP',
  REVIEW_AND_OTHER_PLANS = 'RAO'
}

export const DISCOUNT_TYPE = {
  PERCENTAGE: 'PER',
  MONETARY_VALUE: 'VAL',
};

export const STEPS = {
  DEALERSHIP: 1,
  PICKUPANDELIVERY: 2,
  SERVICES: 3,
  ADVISORDATE: 4,
  RESUME: 5,
  CONFIRMATION: 6
};

export const SESSION_FORD_PROTECT = 'fordProtectData';

export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_FORMAT_DMY = 'DD/MM/YYYY';
export const MOMENT_TIMESTAMP = `${DATE_FORMAT}THH:mm:ss.ssss`;

export const calcBy12 = (n: number) => n / 12;

export const LINK_FORD = 'https://www.ford.com.br';
